import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getDestinos,
  deleteDestino,
  getDestinoById,
} from "../helpers/rutaDestinos";
import ModalDestino from "./ModalDestino";
import "../css/tableclientes.css";

const TableDestinos = () => {
  const [destinos, setDestinos] = useState({
    data: {},
    loading: true,
  });

  const [destino, setDestino] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaDestinos();
  }, []);

  const consultaDestinos = () => {
    getDestinos().then((datos) => {
      console.log("📦 Destinos:", datos);
      setDestinos({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaDestinos();
  };

  const handleShow = () => setShow(true);

  const modificaDestino = (id) => {
    getDestinoById(id).then((resp) => {
      if (resp.ok) {
        setDestino(resp.destino); // ✅ ahora sí solo el objeto destino
        handleShow();
      } else {
        console.error("❌ Error al obtener destino:", resp.error);
      }
    });
  };

  const eliminarDestino = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el destino?");
    if (confirmar) {
      deleteDestino(id).then(() => {
        consultaDestinos();
      });
    }
  };

  return (
    <div className="table-container">
      {!destinos.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Destino</th>
                </tr>
              </thead>
              <tbody>
                {destinos.data.destinos.map((destino) =>
                  destino.activo ? (
                    <tr key={destino._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaDestino(destino._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarDestino(destino._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{destino.coddes}</td>
                      <td>{destino.destino}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalDestino
            show={show}
            handleClose={handleClose}
            destino={destino}
          />
        </>
      )}
    </div>
  );
};

export default TableDestinos;
